import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  LinearProgress,
  makeStyles,
  MenuItem,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import _ from "lodash";
import { Formik, Form, Field } from "formik";
import { CheckboxWithLabel, TextField } from "formik-material-ui";

import SaveIcon from "@material-ui/icons/Save";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";

import SelectAllIcon from "@material-ui/icons/SelectAll";

import { fetchUnit, fetchCurrencies } from "src/redux/actions/reference.action";
import { useDispatch, useSelector } from "react-redux";
import { priceNumberFormat, sumTotal } from "src/utils/Number";
import {
  addProductJob,
  getPurchaseDetails,
  getPurchaseExpense,
  getPurchaseExpenseJob,
  getPurchaseRequesitionJobById,
} from "src/redux/actions/purchaseRequest.action";
import { Alert, AlertTitle } from "@material-ui/lab";
import ProductItemJobModal from "src/components/modals/ProductItemJobModal/ProductItemJobModal";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import LocationModalComponent from "src/components/modals/LocationModalComponent/LocationModalComponent";
import SupplierModal from "src/components/modals/SupplierModal";
import Swal from "sweetalert2";
import Page from "src/components/Page";
import UnitModalComponent from "src/components/modals/UnitModalComponent";
import purchaseRequestReducer from "src/redux/reducers/purchaseRequest.reducer";
const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    flexWrap: "wrap",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    "& .MuiFormControlLabel-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  breadcrumbContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  formContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  rootLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 400,
    padding: 5,
  },
  selectInputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
}));

PurchaseJobItemAddComponent.ProductForm = {
  valueForm: PropTypes.object,
  headerId: PropTypes.number,
};

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        if (values.value > 0) {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        } else {
          onChange({
            target: {
              name: props.name,
              value: null,
            },
          });
        }
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default function PurchaseJobItemAddComponent() {
  const params = useParams();
  const classes = useStyles();

  const history = useHistory();

  const form = useRef();

  const dispatch = useDispatch();
  const { projects } = useSelector((state) => state.productReducer);
  const [openModal, setOpenModal] = useState(false);
  const [openSupplierModal, setOpenSupplierModal] = useState(false);
  const [openUnitModal, setOpenUnitModal] = useState(false);

  const {
    result: { currencyid },
  } = useSelector((state) => state.loginReducer);

  const { units, currencies } = useSelector((state) => state.referenceReducer);

  const {
    purchaseRequestJob,
    purchaseRequesteExpense,
    purchaseRequesteExpenseJob,
    purchaseRequest,
    purchaseRequestDetails,
  } = useSelector((state) => state.purchaseRequestReducer);

  const [openLocationModal, setOpenLocationModal] = useState(false);

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }
    dispatch(getPurchaseRequesitionJobById(params.headerid));
    dispatch(fetchCurrencies(currencyid));
    dispatch(getPurchaseDetails(params.headerid));
    dispatch(getPurchaseRequesitionJobById(params.headerid));
    dispatch(getPurchaseExpenseJob(params.headerid));
    dispatch(getPurchaseExpense(params.headerid));

    return () => {};
  }, []);

  const findExchangeRate = (id) => {
    let result = _.find(currencies.data, { CURRENCY_ID: id });
    if (result) {
      return result.CURRENCY_EXC_ID;
    }
    return 0;
  };

  const renderCurrencies = () => {
    if (currencies.isLoading) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return currencies.data.map((i) => (
      <MenuItem key={i.CURRENCY_ID} value={i.CURRENCY_ID}>
        {i.CURRENCY_EXC_CODE} - {i.CURRENCY_EXC_NAME}
      </MenuItem>
    ));
  };

  if (units.isRejected || currencies.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert — <strong>Get Input Item!</strong>
        </Alert>
      </div>
    );
  }

  const inputOptionsProject = new Promise(function (resolve) {
    // get your data and pass it to resolve()
    if (projects.data) {
      let obj = projects.data.reduce(function (acc, cur, i) {
        acc[cur.BUDGETP_CODE] = cur.BUDGETP_NAME;
        return acc;
      }, {});

      resolve(obj);
    }
    resolve({});
  });

  return (
    <Page className={classes.root} title="Item Form">
      <Container maxWidth={false}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={() => {
              history.replace("/purchase-requisition-job");
            }}
          >
            Purchase Requisition List Job
          </Link>
          <Link
            color="inherit"
            onClick={() => {
              history.goBack();
            }}
          >
            Purchase Requesition Job Edit
          </Link>
          <Link color="textPrimary" aria-current="page">
            Item Form
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader
            subheader="For the purchase requisition adjust on the system."
            title="Item Form"
          />
          <Divider />
          <CardContent>
            <div className={classes.formContainer}>
              <Formik
                key={`ProductForm`}
                ref={form}
                enableReinitialize
                initialValues={{
                  PRHIDX: params.headerid,
                  CURR_ID: currencyid,
                  ITEMS_DETAIL: "",
                  SKUIDX: "",
                  PRICE: "",
                  QTY: "",
                  PR_UNIT: "",
                  EXC_RATE: 0,
                  AMOUNT: "",
                  DF_AMT_THB: 0,
                  DF_PRICE_THB: 0,
                  BGIDX: "",
                  BUDGET_CODE: "",
                  BUDGETP_CODE: "",
                  REMARK: "",
                  PR_BRANDID: "",
                  PR_DEPARTID: "",
                  PO_TYPE: true,
                  VAT_TYPE: false,
                  D_LOC_CODE: "",
                  SUPCODE: "",
                  SUPNAME: "",
                }}
                validate={(values) => {
                  const errors = {};

                  if (!values.ITEMS_DETAIL) {
                    errors.ITEMS_DETAIL = "Required";
                  }

                  if (!values.BUDGET_CODE) {
                    errors.BUDGET_CODE = "Required";
                  }

                  if (!values.PRICE) {
                    errors.PRICE = "Required";
                  }

                  if (!values.QTY) {
                    errors.QTY = "Required";
                  }

                  if (Number(values.QTY) <= 0 || Number(values.QTY) > 1000000) {
                    errors.QTY = "Required";
                  }

                  if (!values.PR_UNIT) {
                    errors.PR_UNIT = "Required";
                  }

                  if (!values.CURR_ID) {
                    errors.CURR_ID = "Required";
                  }

                  if (!values.SUPNAME) {
                    errors.SUPNAME = "Required";
                  }

                  if (!values.D_LOC_CODE) {
                    errors.D_LOC_CODE = "Required";
                  }

                  return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setTimeout(() => {
                    setSubmitting(false);

                    const masterAmount =
                      sumTotal(["AMOUNT"], purchaseRequestDetails.data) +
                      (purchaseRequesteExpense.data &&
                        purchaseRequesteExpense.data.AMOUNT);

                    const jobAmount =
                      sumTotal(["AMOUNT"], purchaseRequestJob.data) +
                      (purchaseRequesteExpenseJob.data &&
                        purchaseRequesteExpenseJob.data.AMOUNT);

                    const currentAmount = jobAmount + values.AMOUNT;

                    if (currentAmount <= masterAmount) {
                      values.BGIDX = Number(values.BGIDX);
                      values.PRICE = Number(values.PRICE);
                      values.PRHIDX = Number(values.PRHIDX);
                      values.QTY = Number(values.QTY);
                      values.CURR_ID = Number(values.CURR_ID);
                      const result = _.find(purchaseRequestJob.data, {
                        CURR_ID: Number(values.CURR_ID),
                      });
                      if (result) {
                        dispatch(
                          addProductJob(
                            values,
                            values.PR_DEPARTID,
                            values.PR_BRANDID,
                            params.year,
                            params.companyid,
                            history
                          )
                        );
                        resetForm({});
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "Warning",
                          text: "Single currency per PR is allowed.",
                        });
                      }
                    } else {
                      Swal.fire({
                        icon: "warning",
                        title: "Warning",
                        text:
                          "The purchase requisition, Should be not over budget of master !",
                      });
                    }
                  }, 500);
                }}
                render={({
                  submitForm,
                  isSubmitting,
                  setSubmitting,
                  touched,
                  errors,
                  values,
                  setFieldValue,
                }) => {
                  return (
                    <Form noValidate>
                      <div>
                        {isSubmitting && <LinearProgress color="secondary" />}
                        <div>
                          <Button
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenModal(true);
                            }}
                            color="primary"
                          >
                            <SelectAllIcon />
                            CHOOSE ITEM
                          </Button>
                          <Button
                            flex={1}
                            variant="contained"
                            color="primary"
                            style={{
                              alignSelf: "center",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenLocationModal(true);
                            }}
                          >
                            <MyLocationIcon />
                            CHOOSE DELIVERY LOCATION
                          </Button>
                        </div>
                        <hr />
                        <div>
                          <Field
                            component={TextField}
                            name="BUDGET_CODE"
                            label="Budget Code"
                            error={Boolean(
                              errors.BUDGET_CODE && errors.BUDGET_CODE
                            )}
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="BUDGETP_CODE"
                            label="Project Code"
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="ITEMS_DETAIL"
                            label="Item Name"
                            error={Boolean(
                              errors.ITEMS_DETAIL && errors.ITEMS_DETAIL
                            )}
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <Field
                            component={TextField}
                            name="PRICE"
                            label="Unit Price"
                            error={Boolean(
                              errors.PRICE && touched.PRICE && errors.PRICE
                            )}
                            onChange={(e) => {
                              setFieldValue("PRICE", e.target.value);

                              if (values.CURR_ID) {
                                setFieldValue(
                                  "EXC_RATE",
                                  findExchangeRate(values.CURR_ID)
                                );
                              }

                              if (values.QTY) {
                                var amount =
                                  values.EXC_RATE * e.target.value * values.QTY;
                                setFieldValue(
                                  "AMOUNT",
                                  parseFloat(parseFloat(amount).toFixed(4))
                                );
                              }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                          <FormControl className={classes.selectInputForm}>
                            <InputLabel
                              error={Boolean(
                                errors.CURR_ID &&
                                  touched.CURR_ID &&
                                  errors.CURR_ID
                              )}
                              id="CURR_ID"
                            >
                              Please Select Currency
                            </InputLabel>
                            <Field
                              labelId="CURR_ID"
                              component={CustomSelectInput}
                              name="CURR_ID"
                              error={Boolean(
                                errors.CURR_ID &&
                                  touched.CURR_ID &&
                                  errors.CURR_ID
                              )}
                              onChange={(e) => {
                                if (values.CURR_ID) {
                                  setFieldValue(
                                    "EXC_RATE",
                                    findExchangeRate(values.CURR_ID)
                                  );
                                }
                                if (values.QTY) {
                                  var amount =
                                    findExchangeRate(e.target.value) *
                                    values.PRICE *
                                    values.QTY;
                                  setFieldValue(
                                    "AMOUNT",
                                    parseFloat(parseFloat(amount).toFixed(4))
                                  );
                                }
                              }}
                            >
                              {renderCurrencies()}
                            </Field>
                          </FormControl>
                        </div>
                        <div>
                          <Field
                            component={TextField}
                            name="QTY"
                            label="QTY"
                            error={Boolean(
                              errors.QTY && touched.QTY && errors.QTY
                            )}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => {
                              setFieldValue("QTY", e.target.value);

                              if (values.CURR_ID) {
                                setFieldValue(
                                  "EXC_RATE",
                                  findExchangeRate(values.CURR_ID)
                                );
                              }
                              if (values.PRICE) {
                                var amount =
                                  values.EXC_RATE *
                                  values.PRICE *
                                  e.target.value;

                                setFieldValue(
                                  "AMOUNT",
                                  parseFloat(parseFloat(amount).toFixed(4))
                                );
                              }
                            }}
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                          <Field
                            label="Unit Type (click)"
                            component={TextField}
                            name="PR_UNIT"
                            id="PR_UNIT"
                            error={Boolean(
                              errors.PR_UNIT &&
                                touched.PR_UNIT &&
                                errors.PR_UNIT
                            )}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenUnitModal(true);
                            }}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                              readOnly: true,
                            }}
                          />
                          <Field
                            label="Supplier (Click)"
                            component={TextField}
                            name="SUPNAME"
                            id="SUPNAME"
                            error={Boolean(
                              errors.SUPNAME &&
                                touched.SUPNAME &&
                                errors.SUPNAME
                            )}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenSupplierModal(true);
                            }}
                            onChange={() => {}}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                              readOnly: true,
                            }}
                          />
                          <Field
                            label="Delivery Location (Click)"
                            component={TextField}
                            name="D_LOC_CODE"
                            id="D_LOC_CODE"
                            error={Boolean(
                              errors.D_LOC_CODE &&
                                touched.D_LOC_CODE &&
                                errors.D_LOC_CODE
                            )}
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenLocationModal(true);
                            }}
                            onChange={() => {}}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                              readOnly: true,
                            }}
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            label="Generate PO"
                            control={
                              <Field
                                id="PO_TYPE"
                                name="PO_TYPE"
                                type="checkbox"
                                component={CheckboxWithLabel}
                              />
                            }
                          />
                        </div>
                        <div>
                          <Typography variant="h6" gutterBottom>
                            Total Amount : {priceNumberFormat(values.AMOUNT)}
                            {"   "}
                          </Typography>
                          <Box display="flex" justifyContent="flex-end">
                            <Box>
                              <Button
                                onClick={submitForm}
                                variant="contained"
                                color="primary"
                              >
                                <SaveIcon />
                                Save
                              </Button>
                            </Box>
                            <Box marginLeft={2}>
                              <Button
                                disabled={isSubmitting}
                                onClick={() => {
                                  history.goBack();
                                }}
                                variant="contained"
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Box>
                        </div>
                      </div>
                      <LocationModalComponent
                        open={openLocationModal}
                        countryid={purchaseRequest.data.PR_COUNTRYID}
                        handleClose={() => {
                          setOpenLocationModal(false);
                        }}
                        handleAdd={(value) => {
                          const { REF_NAME, REF_RCIDX, REF_CODE } = value;
                          setFieldValue("D_LOC_NAME", REF_NAME);
                          setFieldValue("D_LOC", REF_RCIDX);
                          setFieldValue("D_LOC_CODE", REF_CODE);
                        }}
                      />
                      <SupplierModal
                        open={openSupplierModal}
                        handleAdd={(value) => {
                          setFieldValue("SUPCODE", value.SUPCODE);
                          setFieldValue("SUPNAME", value.NAMETHAI);
                        }}
                        handleClose={() => setOpenSupplierModal(false)}
                      />
                      <UnitModalComponent
                        open={openUnitModal}
                        handleClose={() => {
                          setOpenUnitModal(false);
                        }}
                        handleAdd={(value) => {
                          const { REF_CODE } = value;
                          setFieldValue("PR_UNIT", REF_CODE);
                        }}
                      />
                      <ProductItemJobModal
                        open={openModal}
                        handleClose={() => {
                          setOpenModal(false);
                        }}
                        countryid={params.countryid}
                        companyid={params.companyid}
                        secureid={params.secid}
                        year={params.year}
                        handleAdd={(value) => {
                          const result = _.find(purchaseRequestJob.data, {
                            BGIDX: Number(value.BGIDX),
                          });
                          if (result) {
                            if (value.BUDGETP_ID > 0) {
                              Swal.fire({
                                icon: "question",
                                title: "Please select the project.",
                                input: "select",
                                inputOptions: inputOptionsProject,
                                showCancelButton: true,
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  setFieldValue("ITEMS_DETAIL", value.NAME_TH);
                                  setFieldValue("SKUIDX", value.SKUIDX);
                                  setFieldValue("BUDGET_CODE", value.ACC_CODE);
                                  setFieldValue("BUDGETP_CODE", result.value);
                                  setFieldValue("BGIDX", value.BGIDX);
                                  setFieldValue(
                                    "PR_DEPARTID",
                                    value.BUDGETS_DEPARTMENT
                                  );
                                  setFieldValue(
                                    "PR_BRANDID",
                                    value.BUDGETS_BRAND
                                  );
                                  setFieldValue("PR_UNIT", value.UNIT_NAME);
                                }
                              });
                            } else {
                              setFieldValue("ITEMS_DETAIL", value.NAME_TH);
                              setFieldValue("SKUIDX", value.SKUIDX);
                              setFieldValue("BUDGET_CODE", value.ACC_CODE);
                              setFieldValue("BGIDX", value.BGIDX);
                              setFieldValue(
                                "PR_DEPARTID",
                                value.BUDGETS_DEPARTMENT
                              );
                              setFieldValue("PR_BRANDID", value.BUDGETS_BRAND);
                              setFieldValue("PR_UNIT", value.UNIT_NAME);
                            }
                          } else {
                            Swal.fire({
                              icon: "warning",
                              title: "Warning",
                              text:
                                "The purchase requisition, Should use the same the budget code on used!",
                            }).then(() => {
                              setOpenModal(true);
                            });
                          }
                        }}
                      />
                    </Form>
                  );
                }}
              />
            </div>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
